<template>
  <div class="border border-gray rounded-md mx-4 select-none shadow-md">
    <div class="flex flex-col w-full items-center transition-all p-4">
      <div class="flex flex-row w-full gap-3">
        <div class="rounded-full flex flex-none items-center justify-center overflow-hidden h-14 w-14 bg-blue-100">
          <i class="icon-pin text-primary font-bold" style="font-size: 1.8rem"/>
        </div>
        <div class="flex flex-row w-full justify-between">
          <div class="flex flex-col text-left capitalize">
            <h4 class="text-black">{{ $filters.isoFormatter(item?.country_iso).text }}</h4>
            <h5 class="text-gray-400">{{ item?.state }}</h5>
          </div>
          <div class="flex flex-row gap-5 fon-bold">
            <div>
              <i class="icon-chat-edit text-xl cursor-pointer h-auto" @click="$emit('update-trip', item)"/>
            </div>
            <div>
              <i class="icon-delete text-red text-xl cursor-pointer h-auto" @click="$emit('delete-trip', item)"/>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-row gap-4 items-center justify-start w-full mt-4">
        <div class="flex flex-row gap-2 items-center">
          <i class="icon-calendar"/>
          <p>{{ `Desde: ${$filters.moment(item?.start_date, 'DD/MM/YY', true)}` }}</p>
        </div>
        <div class="flex flex-row gap-2 items-center">
          <i class="icon-calendar"/>
          <p>{{ `Hasta: ${$filters.moment(item?.end_date, 'DD/MM/YY', true)}` }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { onMounted } from 'vue'
// import { useSession } from '@/hooks'

export default {
  props: {
    item: { type: Object }
  },
  emits: ['update-trip'],
  setup (props) {
    // const { user: userSession } = useSession()

    return {}
  }
}
</script>

<style scoped>

</style>
